import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Cigna",
  shortName: "Cigna",
  slug: "cigna-insurance",
  seoTitle: "Cigna TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Cigna insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Cigna plan in Coral Springs, FL.",
  seoKeywords:
    "Cigna TMS coverage, Cigna TMS therapy, Cigna depression treatment Florida, Cigna mental health benefits Coral Springs FL, Cigna SAINT TMS",
  planType: "global health insurance provider",
  planRegion: "nationwide",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Cigna is a global health insurance provider offering commercial, employer-sponsored, Medicare Advantage, and individual marketplace plans. Cigna plans typically include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Cigna offers a range of plan types — including HMO, PPO, EPO, and Open Access networks — and coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan and network.",
  officialResourceUrl: "https://www.cigna.com/",
  officialResourceLabel: "Cigna official website",
};

export const CignaInsurance = () => <InsurancePageTemplate config={config} />;
export default CignaInsurance;
